import { EnvironmentProviders, ErrorHandler, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ConsoleErrorLogService } from './console-error-log.service';
import { TELEMETRY_SURFACE } from './diagnostics-snapshot.service';
import { RouteBreadcrumbService } from './route-breadcrumb.service';
import { TelemetryErrorHandler } from './telemetry-error-handler';
import { TelemetrySurface } from './telemetry.model';

/**
 * Wires up the diagnostics buffers a feedback report attaches to itself. Register the companion
 * `telemetryInterceptor` FIRST in the app's `withInterceptors([...])`.
 *
 * `surface` is a required argument rather than a detected value: this module is shared by both
 * apps, and neither `@capacitor/core` nor any other platform probe belongs in `core/telemetry`.
 */
export function provideTelemetry(surface: TelemetrySurface): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: TELEMETRY_SURFACE, useValue: surface },
    { provide: ErrorHandler, useClass: TelemetryErrorHandler },
    provideAppInitializer(() => {
      inject(ConsoleErrorLogService).start();
      inject(RouteBreadcrumbService).start();
    }),
  ]);
}
